import { useState } from "react";
import Browser from "../browser";
import { useRedraw } from "../models/useRerender";
import { itx } from "../translationItx/itx";

export default function FirefoxAlert() {
  const redraw = useRedraw();

  if ((window as any).closedFirefoxAlert || !Browser.isFirefox()) {
    return null;
  }

  return (
    <div
      className="dialogWrapper"
      onClick={() => {
        (window as any).closedFirefoxAlert = true;
        redraw();
      }}
    >
      <div
        style={{
          padding: "20px",
          boxShadow: "var(--panel-shadow)",
          border: "1px solid var(--border-color)",
          borderRadius: "5px",
          backgroundColor: "white",
        }}
      >
        <b>{itx("FirefoxAlert.achtung", "Achtung:")}</b>{" "}
        {itx("FirefoxAlert.estadauntersttztfirefox", "Estada unterstützt Firefox.")} <br />
        {itx("FirefoxAlert.frdiebeste", "Für die beste Benutzererfahrung verwende bitte Chrome.")}
        <br />
        <br />
        <button
          className="button"
          style={{ marginLeft: "20px" }}
          onClick={() => {
            (window as any).closedFirefoxAlert = true;
            redraw();
          }}
        >
          Verstanden
        </button>
      </div>
    </div>
  );
}
